import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import VueElementLoading from 'vue-element-loading';
import Paginate from "vuejs-paginate";
import PageTracker from '../../../common/PageTrackerHelper'
import {
  BasicSelect
} from 'vue-search-select';
import keycloak from '../../../common/Keycloak';

export default {
  name: 'printShipmentForDelivery',
  components: {
    VueElementLoading,
    Paginate,
    BasicSelect,
    PageTracker,
    DatePicker
  },
  mixins:[PageTracker],
  data: function() {
    return {
      loader:'<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
      srIdFlt:'',
      srItemObjFlt:{ value: "",text: ""},
      srListFlt:[],
      deliveryOptionPrint:'',
      deliveryOptionItemObjPrint:{ text: ""},
      deliveryOptionListPrint:[{ text: "RTO"},{ text: "DTO"},{ text: "RVP"},{ text: "Delivery"}],
      batchIdPrint:'',
      batchIdItemObjPrint:{text: ""},
      batchIdListPrint:[],
      srShipmentPrintList:[],
      fromListFlt:[{ value: "FromWeb",text: "From Web"}],
      fromItemObjFlt:{ value: "FromWeb",text: "From Web"},
      fromIdFlt:null,
      batchCreatedDate:'',
      srLoader:'',
      disableBatchID:false,
      disableFrom:false,
      isLoadPDF:false,
      isLoadBatch:false,
      isLoadingPrint:false,
      futuredate:false,
      pastdate:false,
      srArrayList:[],
      todayDate:'',
      srSelected : false,
      isCreateDate : false,
      userDataKey : '',
    }
  },
  created: function() {

  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    batchCreatedDateFormat:function(date){
      if(date==null)return ''
      return moment(date).format('DD-MM-YYYY');
    }
  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.localuseroutsourcingid = userdetail.outsourcingid;
    this.CourierCompanyID = this.localuseroutsourcingid;
    this.userHubId = userdetail.hubdetails[0] == undefined ? 0 : userdetail.hubdetails[0]

    const IsRVPPaperlessEncrypt = window.localStorage.getItem('IsRVPPaperless')
    const IsRVPPaperlessbytes = CryptoJS.AES.decrypt(IsRVPPaperlessEncrypt.toString(), this.userDataKey);
    const IsRVPPaperlessbytestext = IsRVPPaperlessbytes.toString(CryptoJS.enc.Utf8);
    const paperLessKey = JSON.parse(IsRVPPaperlessbytestext)
    this.loadSRList(this.userHubId)
    if(paperLessKey != null && paperLessKey.trim() == "1") {
      this.IsRVPPaperless = true;
      this.deliveryOptionListPrint.splice(2, 1) ;
    } else {
      this.IsRVPPaperless = false;
    }
    if(this.userHubId==1091) {
      var fromListFlt = this.fromListFlt.filter(n => {
        if(n.value!=null) {
          return n
        }
      })
      this.fromListFlt = fromListFlt
      this.fromItemObjFlt = { value: 'FromWeb',text: "From Web"}
      this.fromIdFlt = 'FromWeb'
    }

    let TrackerInfo = {
      projectname:"Last Mile",
      type:"Web",
      userid:this.localuserid,
      username:this.localusermailid,
      meta: {
        "event":""
      }
    }
    let result  = this.PageTracker(TrackerInfo);
    //console.log('Mixin is working for :',result);
  },
  methods: {
    loadSRList(hubid) {
      this.srLoader = this.loader
      this.srArrayList = []
      this.srListFlt = []
      if(hubid) {
        let Emppayload = {
          "OutSourcingId": this.CourierCompanyID,
          "hubid": [hubid]
        }
        let apiendpoint = 'agenthandovershipments/getDeliveryUserName';
        if (keycloak.enableKavach) {
          apiendpoint = 'user/migration/getoutsourceuserlist';
        }
        axios.post(apiUrl.api_url + apiendpoint, {
            Emppayload
          })
        .then(response => {
          this.srLoader = ''
          if (response.data.code === 200) {
            $.each(response.data.data , (key,obj)=>{
              this.srListFlt.push({
                value: `${obj.DeliveryUserId}`,
                text: `${obj.FirstName} ${obj.LastName} (${obj.OldDeliveryUserOrUserId} - ${obj.DeliveryUserId}) - (${obj.MobileNumber})`
              })
            })
            this.srArrayList = response.data.data
          } else {
            this.srListFlt = [];
            this.$alertify.error("Delivery User Data Not Found");
            return false
          }
          this.srLoader = ''
        }, error => {
          this.srLoader = ''
          console.error(error)
          return false
        })
      } else {
        this.$alertify.error("Current Hub Id not found.")
        return false
      }
    },
    selectSRFlt(obj) {
      this.srItemObjFlt = obj
      this.srIdFlt = obj.value
      this.srSelected = true
    },
    selectFromFlt(obj) {
      this.fromItemObjFlt = obj
      this.fromIdFlt = obj.value
    },
    dateSelected(){
      this.isCreateDate = true
    },
    selectDeliveryOptionPrint(obj) {
      this.batchIdListPrint = [];
      this.deliveryOptionItemObjPrint = obj;
      this.deliveryOptionPrint = obj.text;
    },
    printShipmentForDelivery() {
      if(this.deliveryOptionPrint == ''){
        this.$alertify.error('Please select Delivery Option');
        return false;
      }
      if(this.batchCreatedDate == '' || this.batchCreatedDate == null){
        this.$alertify.error('Please select Created Date');
        this.isCreateDate = false
        return false;
      }else {
        this.isCreateDate = true
      }
      var selectedSrDtl = this.srArrayList.filter(n=>{
        return n.DeliveryUserId==this.srIdFlt
      })
      this.srNameShipPrint = selectedSrDtl[0].FirstName+" "+selectedSrDtl[0].LastName+" ("+selectedSrDtl[0].userid+")"
      this.srPhoneShipPrint = selectedSrDtl[0].MobileNumber?selectedSrDtl[0].MobileNumber.toString():""
      // if ((this.deliveryOptionPrint=='RVP' || this.deliveryOptionPrint=='RTO' || this.deliveryOptionPrint=='DTO')) {
        this.batchIdListPrint = [];
        this.shippingIDArray = [];
        this.isLoadBatch = true;
        let batchCdate =  moment(this.batchCreatedDate).format('YYYY-MM-DD');
        this.todayDate = new Date();
        let Today = moment(this.todayDate).format('YYYY-MM-DD');
        if(batchCdate < Today){
          this.pastdate = true;
          this.futuredate = false;
        }
        else {
          this.futuredate = true;
          this.pastdate = false;
        }
        let batchpayload = {
          "UserHubID": this.userHubId.toString(),
          "DeliveryUserID": this.srIdFlt,
          "shipmentType":this.deliveryOptionPrint,
          "createdDate":batchCdate
          //"FromDate": fromrvpdate,
          //"ToDate": torvpdate
        }
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'expose/get/batchid',
          data: batchpayload
        })
        .then(result => {
          if (result.data.code==200) {
            this.isLoadBatch = false
            for (var i = 0; i < result.data.PrintBatchId.length; i++) {
              this.shippingIDArray = []
              for(var j=0 ;j<result.data.PrintBatchId[i].NoOfShipments; j++){
                this.shippingIDArray.push({
                  shippingIDArray : result.data.PrintBatchId[i].ShippingIDs[j].ShippingID
                  })
                }
                  this.batchIdListPrint.push({
                    AssignBatchNo : result.data.PrintBatchId[i].AssignBatchNo,
                    NoOfShipments : result.data.PrintBatchId[i].NoOfShipments,
                   shippingIDArray : this.shippingIDArray
                  })
                }
              }
           else {
            this.isLoadBatch = false
            this.$alertify.error(result.data.message)
          }
        }, error => {
          console.error(error)
        })
    },
    printShipmentForRVP(AssignBatchNo,pdfType){
      let responseType = 'blob';
      this.isLoadPDF = true
      let batchCrdate = moment(this.batchCreatedDate).format('YYYY-MM-DD');
      this.input = {
        "DeliveryUserID" : this.srIdFlt,
        "PrintFrom": this.fromIdFlt,
        "ShipmentType": this.deliveryOptionPrint,
        "BatchId": AssignBatchNo,
      //  "PrintType":pdfType,
        "UserName":this.createdBy,
        "date":batchCrdate
      }
      if(pdfType == 'olddrs'){
        this.input.SheetType = pdfType
      }
      else {
        this.input.PrintType = pdfType
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'expose/web/get/shipmentbysrid',
        data: this.input,
        responseType: responseType
      })
      .then(async result => {
           if(result.status == 200 ) {
            const downloadUrl = window.URL.createObjectURL(new Blob([result.data], { type: 'application/pdf' }))
            let message = {
                title: '',
                body: `<p>Pdf is generated, Would you like to open.!</p>`,
              };

              let res = this.$dialog.alert(message, {
                html: true,
                animation: 'bounce',
                backdropClose: false,
                loader: true
              })
              .then(dialog => {
                  window.open(downloadUrl);
                  this.isLoadPDF = false
                  dialog.close();
              })
              .catch(() => {
                this.isLoadPDF = false
              })
             try {
               let TrackerInfo = {
                 projectname: "Last Mile",
                 type: "Web",
                 routeurl: "expose/web/get/shipmentbysrid",
                 userid: this.localuserid,
                 username: this.localusermailid,
                 meta: {
                   event: "expose-web-get-shipmentbysrid",
                   shipmentId: null,
                   hubId: this.userHubId ? this.userHubId : null,
                   remarks: "FrontEnd",
                 },
               };
               Object.assign(TrackerInfo.meta, this.input);
               this.PageTracker(TrackerInfo);
             } catch (error) {
               console.log(error);
             }
          } else {
            this.isLoadPDF = false;
            this.$alertify.error('Unable to load pdf, Please try after sometime.!');
          }
      }, error => {
        this.isLoadPDF = false;
        console.error(error)
      })
    },
    exportCSVOfShippingIDS(result) {
      let csvContent = "data:text/csv;charset=utf-8,";
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      let filename = "ShippingID" + today + ".csv";
      csvContent += ['ShippingID',
    //    Object.keys(result).join(";"),
        ...result.map(item => Object.values(item).join(";"))
      ]
      .join("\n")
      .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      link.click();
    },
    selectBatchIdPrint(obj) {
      this.batchIdItemObjPrint = obj
      this.batchIdPrint = obj.text
    },
    resetPrint(){
        this.$validator.reset();
        this.deliveryOptionItemObjPrint = {};
        this.srItemObjFlt = {}
        this.srIdFlt = ''
        this.deliveryOptionPrint = ''
        this.isLoadBatch = false
        this.isLoadingPrint = false
        this.batchIdListPrint = []
        this.batchCreatedDate = ''
        this.srSelected = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/PrintShipmentForDelivery/PrintShipmentForDelivery.js